// Replaces ${xxxx} in template with object properties
export const stringInterpolate = (template, props, fallback) => (template || '').replace(/\$\{[^}]+\}/g, (match) => match
  .slice(2, -1)
  .trim()
  .split('.')
  .reduce((searchObject, key) => ((searchObject[key] != null && searchObject[key].toString()) || fallback || match), props));
